import React from 'react';
import PointCauseSaveInfo from '../PointCauseSaveInfo';
import PointCauseSaveNavBar from '../PointCauseSaveNavBar';

const PointCauseSaveWrap = (props) => {
  const { form, onSubmit, setData } = props;

  return (
    <div className="point-cause-save-wrap">
      <PointCauseSaveNavBar onSubmit={onSubmit} />

      <PointCauseSaveInfo
        form={form}
        setData={(data) =>
          setData({
            path: ['pointCauseSave', 'pointCauseInfo', ...data.path],
            value: data.value,
          })
        }
      />
    </div>
  );
};

export default PointCauseSaveWrap;
